import React from "react";
import { useNavigate } from "react-router-dom";

import { extractDate } from "../../../Components/Functions/date.fun";
const tableHead = [
  "Sr.",
  "Lead Generate Date",
  "full name",
  "contact number",
  "lead owner",

  "interested In",
  "lead status",
  "Actions",
];

const getInterest = (item) => {
  if (item?.interestedIn && item?.interestedIn.length >= 1) {
    return item?.interestedIn.join(", ");
  }
  if (!item?.lead_status) {
    return "Not Attended";
  }
  return "N/A";
};
const ColdLeadsTable = ({ leads = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/leads/view-lead/${id}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {leads?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{extractDate(item?.createdAt) || "N/A"}</td>
                <td style={{ maxWidth: "200px" }}>
                  <span
                    className="cursor-pointer text-blue text-decoration-underline"
                    onClick={() => goToView(item.id)}
                  >
                    {item?.full_name || "N/A"}
                  </span>
                </td>
                <td>{item?.phone_number || "N/A"}</td>
                <td>{item?.lead_alloted_to || "N/A"}</td>

                <td style={{ maxWidth: "200px" }}>{getInterest(item)}</td>
                <td>{item?.lead_status || "N/A"}</td>

                <td>
                  <button
                    style={{ width: "60px", height: "30px" }}
                    className="btn btn-primary"
                    onClick={() => goToView(item.id)}
                  >
                    View
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ColdLeadsTable;
